import moment from 'moment';
import { Row, RenderConfig, TextInput, Column, EMPTY_ARRAY, SelectInput } from 'commons-ui';
import { EntityOption } from 'pages/dashboard/downtimeRefund/listRefundRequest/types';
import { DOWNTIME_REFUND_MINIMUM_TIME_DIFF_IN_MINUTES } from 'constant';

export const FORM_FIELD_KEYS = {
	GAME_NAME: 'gameName',
	DOWNTIME_TYPE: 'downtimeType',
	START_TIME: 'startTime',
	END_TIME: 'endTime'
};

export const DOWNTIME_TYPE = {
	GAME_NOT_STARTED: 'Game not started',
	WD_DECLARD_MONEY_NOT_REFUNDED: 'WD declared | money not refunded | 3 tto nonNx | 1 TTO nx',
	WD_NOT_DECLARED: 'WD not declared | with/without TTO | nx + nonNx'
};
const downtimeOptions: EntityOption[] = Object.entries(DOWNTIME_TYPE).map(([id, label]) => ({ id, label }));

export const FORM_FIELD_LABELS: {
	[key: string]: string;
} = {
	[FORM_FIELD_KEYS.GAME_NAME]: 'Game Name',
	[FORM_FIELD_KEYS.DOWNTIME_TYPE]: 'Downtime Type',
	[FORM_FIELD_KEYS.START_TIME]: 'Start Time',
	[FORM_FIELD_KEYS.END_TIME]: 'End Time'
};

export const GAME_OPTIONS: EntityOption[] = [
	{
		label: 'LUDO',
		id: 'ludo'
	},
	{
		label: 'NINJA',
		id: 'ninja'
	},
	{
		label: 'SNLT',
		id: 'snlt'
	},
	{
		label: 'TURBO',
		id: 'turbo'
	},
	{
		label: 'TC',
		id: 'tc'
	},
	{
		label: 'LUDO SUPREME LEAGUE',
		id: 'ludonx'
	},
	{
		label: 'HC',
		id: 'hc'
	}
];

export const INPUT_TYPES = {
	DATETIME_LOCAL: 'datetime-local'
};

export const FORMATS: {
	[key: string]: string;
} = {
	[INPUT_TYPES.DATETIME_LOCAL]: 'yyyy-MM-dd HH:mm:ss'
};

const maxDate = moment().subtract(DOWNTIME_REFUND_MINIMUM_TIME_DIFF_IN_MINUTES, 'minutes').format('YYYY-MM-DD HH:mm:ss');

export const FORM_FIELD_CONFIG: {
	[key: string]: RenderConfig;
} = {
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.GAME_NAME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.GAME_NAME])
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: GAME_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.DOWNTIME_TYPE]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.DOWNTIME_TYPE)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.DOWNTIME_TYPE])
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: downtimeOptions,
			required: true
		}),
	[FORM_FIELD_KEYS.START_TIME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.START_TIME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.START_TIME])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			inputType: INPUT_TYPES.DATETIME_LOCAL,
			format: FORMATS[INPUT_TYPES.DATETIME_LOCAL],
			required: true
		}),
	[FORM_FIELD_KEYS.END_TIME]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.END_TIME)
		.setLabel(FORM_FIELD_LABELS[FORM_FIELD_KEYS.END_TIME])
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			inputType: INPUT_TYPES.DATETIME_LOCAL,
			format: FORMATS[INPUT_TYPES.DATETIME_LOCAL],
			required: true,
			max: maxDate
		})
};

export const FORM_LAYOUT_CONFIG: Row[] = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.GAME_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.DOWNTIME_TYPE)])
	]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.START_TIME)]), new Column([new Row(FORM_FIELD_KEYS.END_TIME)])])
];
